import NavigationComponent from 'components/navigationComponents/NavigationComponent'
import FooterComponent from 'components/footerComponents/FooterComponent'
import CartComponent from 'components/cart2Component/CartComponent';


function Cart2() {
  return (
    <div>
        <NavigationComponent/>
        <CartComponent/>
        <FooterComponent/>
    </div>
  )
}

export default Cart2;